import useQuantityInput from '../components/useQuantityInput';
import handleCartAction from '../components/UseHandleCartAction';

export default function initSideCart() {
  const { prestashop, Theme } = window as any;
  if (!prestashop || !Theme) return;

  // Nie inicjuj sidecarta na koszyku/checkout
  const path = window.location.pathname;
  if (
    path.indexOf('/cart') === 0 ||
    path.indexOf('/order') === 0 ||
    path.indexOf('/checkout') === 0
  ) {
    return;
  }

  const sideCart = document.getElementById('side-cart') as HTMLElement | null;
  if (!sideCart) return;

  const panel = sideCart.querySelector('.side-cart__panel') as HTMLElement | null;
  const overlay = sideCart.querySelector('.side-cart__overlay') as HTMLElement | null;
  const closeBtn = sideCart.querySelector('.side-cart__close') as HTMLElement | null;
  const content = sideCart.querySelector('.js-side-cart-content') as HTMLElement | null;

  if (!panel || !overlay || !closeBtn || !content) return;

  // pewne referencje (bez null)
  const sideCartEl: HTMLElement = sideCart;
  const panelEl: HTMLElement = panel;
  const overlayEl: HTMLElement = overlay;
  const closeBtnEl: HTMLElement = closeBtn;
  const contentEl: HTMLElement = content;

  let hideTimeout: number | null = null;
  let isHovering = false;

  const AUTO_HIDE_DELAY = window.matchMedia('(max-width: 767px)').matches ? 500000 : 30000;

  function openSideCart() {
    sideCartEl.classList.add('is-visible');
    panelEl.classList.add('is-open');

    sideCartEl.setAttribute('aria-hidden', 'false');

    if (hideTimeout) window.clearTimeout(hideTimeout);
    hideTimeout = window.setTimeout(() => {
      if (!isHovering) closeSideCart();
    }, AUTO_HIDE_DELAY);
  }

  function closeSideCart() {
    panelEl.classList.remove('is-open');
    sideCartEl.setAttribute('aria-hidden', 'true');

    window.setTimeout(() => {
      sideCartEl.classList.remove('is-visible');
    }, 300);
  }

  panelEl.addEventListener('mouseenter', () => {
    isHovering = true;
    if (hideTimeout) window.clearTimeout(hideTimeout);
  });

  panelEl.addEventListener('mouseleave', () => {
    isHovering = false;
    hideTimeout = window.setTimeout(() => {
      if (!isHovering) closeSideCart();
    }, AUTO_HIDE_DELAY); //1000
  });

  overlayEl.addEventListener('click', closeSideCart);
  closeBtnEl.addEventListener('click', closeSideCart);

  function updateSummary(cart: any) {
    const itemsEl = sideCartEl.querySelector('.js-sidecart-items-count') as HTMLElement | null;
    const productsEl = sideCartEl.querySelector('.js-sidecart-subtotal-products') as HTMLElement | null;
    const shippingEl = sideCartEl.querySelector('.js-sidecart-subtotal-shipping') as HTMLElement | null;
    const totalEl = sideCartEl.querySelector('.js-sidecart-total') as HTMLElement | null;

    if (!itemsEl || !productsEl || !shippingEl || !totalEl) return;

    const itemsCount =
      typeof cart.products_count !== 'undefined'
        ? Number(cart.products_count)
        : (cart.products?.reduce((acc: number, p: any) => acc + (Number(p.quantity) || 0), 0) ?? 0);

    itemsEl.textContent = String(itemsCount);

    productsEl.textContent = cart.subtotals?.products?.value || '€0.00';
    shippingEl.textContent = cart.subtotals?.shipping?.value || '€0.00';
    totalEl.textContent = cart.totals?.total?.value || '€0.00';
  }

  function renderEmpty() {
    contentEl.innerHTML = `<p class="side-cart__empty">${(sideCartEl.querySelector('.side-cart__empty')?.textContent || 'Your cart is empty')}</p>`;

    // reset summary to defaults (0)
    const itemsEl = sideCartEl.querySelector('.js-sidecart-items-count') as HTMLElement | null;
    const productsEl = sideCartEl.querySelector('.js-sidecart-subtotal-products') as HTMLElement | null;
    const shippingEl = sideCartEl.querySelector('.js-sidecart-subtotal-shipping') as HTMLElement | null;
    const totalEl = sideCartEl.querySelector('.js-sidecart-total') as HTMLElement | null;

    if (itemsEl) itemsEl.textContent = '0';
    if (productsEl) productsEl.textContent = '€0.00';
    if (shippingEl) shippingEl.textContent = '€0.00';
    if (totalEl) totalEl.textContent = '€0.00';
  }

  function renderSideCart(cart: any) {
    if (!cart || !cart.products || !cart.products.length) {
      renderEmpty();
      return;
    }

    let html = '<ul class="side-cart__list">';

    cart.products.forEach((p: any) => {
      const imgUrl =
        p.cover && p.cover.bySize && p.cover.bySize.cart_default
          ? p.cover.bySize.cart_default.url
          : '';

      const thumb = imgUrl
        ? `<img class="side-cart__img" src="${imgUrl}" alt="${p.name}">`
        : `<span class="side-cart__img side-cart__img--placeholder"></span>`;

      html += `
        <li class="side-cart__item"
            data-id-product="${p.id_product}"
            data-id-product-attribute="${p.id_product_attribute || 0}"
            data-id-customization="${p.id_customization || 0}">

          <div class="side-cart__top">
            <a class="side-cart__thumb" href="${p.url}">
              ${thumb}
            </a>

            <a class="side-cart__name" href="${p.url}">
              ${p.name}
            </a>

            <a
              class="side-cart__remove remove-from-cart"
              rel="nofollow"
              href="${p.remove_from_cart_url}"
              data-link-action="delete-from-cart"
              data-product-url="${p.url}"
              data-product-name="${p.name}"
              aria-label="Remove from cart"
            >&times;</a>
          </div>

          <div class="side-cart__bottom">
            <div class="side-cart__unit-price">${p.price}</div>

            <div class="quantity-button js-quantity-button js-sidecart-qty">
              <div class="input-group flex-nowrap justify-content-center">
                <button role="button"
                        aria-label="decrement"
                        class="btn decrement js-decrement-button"
                        type="button">
                  <i class="material-icons" aria-hidden="true"></i>
                  <i class="material-icons confirmation d-none"></i>
                  <div class="spinner-border spinner-border-sm align-middle d-none" role="status"></div>
                </button>

                <input
                  class="js-cart-line-product-quantity form-control"
                  name="product-quantity-spin"
                  data-update-url="${p.update_quantity_url}"
                  data-product-id="${p.id_product}"
                  value="${p.quantity}"
                  min="1"
                  aria-label="Quantity"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                >

                <button role="button"
                        aria-label="increment"
                        class="btn increment js-increment-button"
                        type="button">
                  <i class="material-icons" aria-hidden="true"></i>
                  <i class="material-icons confirmation d-none"></i>
                  <div class="spinner-border spinner-border-sm align-middle d-none" role="status"></div>
                </button>
              </div>
            </div>
          </div>
        </li>
      `;
    });

    html += '</ul>';

    contentEl.innerHTML = html;

    // aktualizacja summary (TPL placeholders)
    updateSummary(cart);

    // natywna logika ilości (w tym confirmation mode)
    useQuantityInput('.js-sidecart-qty');

    // natywne usuwanie (jak w koszyku)
    const removeLinks = contentEl.querySelectorAll<HTMLAnchorElement>('.side-cart__remove');
    removeLinks.forEach((link) => {
      link.addEventListener('click', handleCartAction);
    });
  }

  // Obsługa updateCart – JSON albo Response
  const { events } = Theme;

  const handleUpdateCart = (event: any) => {
    if (!event || !event.resp) return;

    const resp = event.resp as any;

    // JSON case
    if (resp.cart) {
      if (resp.hasError) return;
      renderSideCart(resp.cart);
      openSideCart();
      return;
    }

    // Response case (UseHandleCartAction)
    if (typeof resp.json === 'function') {
      resp
        .clone()
        .json()
        .then((data: any) => {
          if (!data || !data.cart || data.hasError) return;
          renderSideCart(data.cart);
          openSideCart();
        })
        .catch(() => {
          // brak JSON-a -> nic nie robimy
        });
    }
  };

  prestashop.on(events.updateCart, handleUpdateCart);
  prestashop.on('updateCart', handleUpdateCart);

  // Klik w ikonę koszyka w headerze: otwórz drawer
  const headerCart = document.querySelector('.js-cart, .shopping-cart, #_desktop_cart') as HTMLElement | null;
  if (headerCart) {
    headerCart.addEventListener('click', (e: Event) => {
      e.preventDefault();
      openSideCart();
    });
  }
}
